import { useState } from "react"
import PropTypes from "prop-types"
import { apiAsync } from "utils/api"
import PanelTextEditor from "components/admin/PanelTextEditor"

const EventConfirmationEmail = ({ event: eventFromProps }) => {
  const [status, setStatus] = useState(null)
  const [event, setEvent] = useState(eventFromProps)

  const handleSave = async (message, handleClose) => {
    const response = await apiAsync.put(event.paths.customEmailMessage, {
      event: { custom_email_message: message }
    })

    if (response.errors) {
      setStatus({
        text: response.errors || "Changes not saved",
        icon: "general#exclamation-triangle",
        type: "error"
      })
    } else {
      setEvent(response.event)
      handleClose()
    }
  }

  return (
    <PanelTextEditor
      name="customEmailMessage"
      heading="Custom confirmation message"
      blankStateMessage="You can include a custom message in the confirmation email that people receive when they register."
      blankStateButtonLabel="Edit message"
      contentHtml={event.customEmailMessage}
      saveStatus={status}
      onSave={handleSave}
      paneTitleClass="pane__title--matchTable"
    />
  )
}

EventConfirmationEmail.propTypes = {
  event: PropTypes.shape({
    customEmailMessage: PropTypes.string,
    paths: PropTypes.shape({
      customEmailMessage: PropTypes.string
    })
  })
}

export default EventConfirmationEmail
